export enum eUnderwriter {
  WFG = 'WFG',
  Fidelity = 'Fidelity',
  AmericanDigital = 'AmericanDigital',
  FirstAmerican = 'FirstAmerican',
}
